import { Helmet } from 'react-helmet-async'
import { ResponsiveRender } from '@machobear/design-system'
import { MobileLayout } from './mobile-layout'
import { DesktopLayout } from './desktop-layout'
import { useListingData } from '../context/listing-data'

export const ListingDashboardPageLayout = () => {
  const { listingAddress } = useListingData()

  return (
    <>
      <Helmet>
        <title>{listingAddress}</title>
      </Helmet>

      <ResponsiveRender above="tablet">
        <DesktopLayout />
      </ResponsiveRender>

      <ResponsiveRender below="desktop">
        <MobileLayout />
      </ResponsiveRender>
    </>
  )
}
